window.addEventListener('scroll', function() {
    const stickySearch = document.querySelector('.sticky-search-filter');
    if (stickySearch) {
        const scrollPosition = window.scrollY || window.pageYOffset;
        
        if (scrollPosition > 870) {
            stickySearch.classList.remove('hidden');
        } else {
            stickySearch.classList.add('hidden');
        }
    }
});